import { Route, Routes } from "react-router";
import WaitlistHome from './home';

export function WaitlistRouter(props){
    return (
        <Routes>
                <Route path='' >
                    <Route path="" element={<WaitlistHome />} />
                    <Route path="r/:id" element={<WaitlistHome />} />
                    <Route path="*" element={<WaitlistHome />} />
                </Route>
                <Route path="*" element={<WaitlistHome />} />
        </Routes>
    );
}